(function () {
  'use strict';
  var popup = document.getElementById('elyone-welcome-popup');
  if (!popup) return;

  var SEEN_KEY = 'elyonePopupSeen';
  var formStep = popup.querySelector('[data-elyone-popup-step="form"]');
  var successStep = popup.querySelector('[data-elyone-popup-step="success"]');

  function openPopup() {
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
  }
  function closePopup() {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
  }

  popup.querySelectorAll('[data-elyone-popup-close]').forEach(function (el) {
    el.addEventListener('click', closePopup);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-visible')) closePopup();
  });

  var copyBtn = popup.querySelector('[data-elyone-copy-code]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = 'BIENVENUE10';
      var original = copyBtn.textContent;
      function done() {
        copyBtn.textContent = 'Copié !';
        copyBtn.classList.add('is-copied');
        setTimeout(function () {
          copyBtn.textContent = original;
          copyBtn.classList.remove('is-copied');
        }, 2000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        done();
      }
    });
  }

  /* Returning from a successful newsletter submission (full page post-back):
     window.elyonePopupSuccess is set inline, before this deferred script runs. */
  if (window.elyonePopupSuccess) {
    if (formStep) formStep.hidden = true;
    if (successStep) successStep.hidden = false;
    try { localStorage.setItem(SEEN_KEY, 'true'); } catch (e) {}
    openPopup();
    return;
  }
  // Ne jamais afficher le pop-up sur les pages produit
  if (window.location.pathname.indexOf('/products/') !== -1) return;
  var alreadySeen = false;
  try { alreadySeen = localStorage.getItem(SEEN_KEY) === 'true'; } catch (e) {}
  if (alreadySeen) return;

  setTimeout(function () {
    try { localStorage.setItem(SEEN_KEY, 'true'); } catch (e) {}
    openPopup();
  }, 30000);
})();
